import { getRandomDarkColor } from "utils/commonUtils";

export const users = [
  {
    guid: "a9b8c7d6e5f4g3h2i1j0",
    username: "Alex Turner",
    fname: "Alex",
    lname: "Turner",
    email: "alex.turner@example.com",
    position: "Frontend Developer",
    isCandidate: true,
    socketId: "",
    colorCode: "#848484",
    isCameraOn: true,
    isAudioOn: true,
    isJoin: false,
  },
  {
    guid: "b1c2d3e4f5g6h7i8j9k0",
    username: "Monica Bell",
    fname: "Monica",
    lname: "Bell",
    email: "monica.bell@example.com",
    position: "Product Manager",
    isCandidate: false,
    socketId: "",
    colorCode: "#f26a00",
    isCameraOn: true,
    isAudioOn: true,
    isJoin: false,
  },
  {
    guid: "c1d2e3f4g5h6i7j8k9l0",
    username: "Ravi Patel",
    fname: "Ravi",
    lname: "Patel",
    email: "ravi.patel@example.com",
    position: "Backend Developer",
    isCandidate: false,
    socketId: "",
    colorCode: "#3357FF",
    isCameraOn: true,
    isAudioOn: true,
    isJoin: false,
  },
  {
    guid: "d1e2f3g4h5i6j7k8l9m0",
    username: "Sara Lee",
    fname: "Sara",
    lname: "Lee",
    email: "sara.lee@example.com",
    position: "DevOps Engineer",
    isCandidate: false,
    socketId: "",
    colorCode: "#FF33A8",
    isCameraOn: true,
    isAudioOn: true,
    isJoin: false,
  },
];

export function getUserDataByGuid(
  guid,
  jobPosition,
  interviewerJson,
  candidateJson,
  candidateApplicationGuid
) {
  const matchedUser = interviewerJson.find((user) => user.guid === guid);

  if (!matchedUser) {
    return;
  }

  const participantOfMeeting = interviewerJson
    .filter((user) => user.guid !== guid)
    .map((user) => ({
      guid: user.guid,
      username: user.firstName + " " + user.lastName,
      fname: user.firstName,
      lname: user.lastName,
      email: user.email,
      position: user.position,
      isCandidate: false,
      colorCode: getRandomDarkColor(),
      isCameraOn: true,
      isAudioOn: true,
      socketId: user.socketId,
    }));

  return {
    userData: {
      guid: matchedUser.guid,
      username: matchedUser.firstName + " " + matchedUser.lastName,
      fname: matchedUser.firstName,
      lname: matchedUser.lastName,
      email: matchedUser.email,
      position: matchedUser.position,
      InterviewTitle: jobPosition,
      isCandidate: false,
      colorCode: getRandomDarkColor(),
      isCameraOn: true,
      isAudioOn: true,
      socketId: matchedUser.socketId,
    },
    participantOfMeeting: [
      ...participantOfMeeting,
      {
        guid: candidateJson.guid,
        username: candidateJson.firstName + " " + candidateJson.lastName,
        fname: candidateJson.firstName,
        lname: candidateJson.lastName,
        email: candidateJson.email,
        position: candidateJson.position,
        isCandidate: true,
        colorCode: getRandomDarkColor(),
        isCameraOn: true,
        isAudioOn: true,
        socketId: candidateJson.socketId,
      },
    ],
  };
}

export function getParticipantDataForCandidate(
  jobPosition,
  interviewerJson,
  candidateJson,
  candidateApplicationGuid
) {
  const participantOfMeeting = interviewerJson.map((user) => ({
    guid: user.guid,
    username: user.firstName + " " + user.lastName,
    fname: user.firstName,
    lname: user.lastName,
    email: user.email,
    position: user.position,
    isCandidate: false,
    colorCode: getRandomDarkColor(),
    isCameraOn: true,
    isAudioOn: true,
    socketId: user.socketId,
  }));

  return {
    userData: {
      guid: candidateJson.guid,
      username: candidateJson.firstName + " " + candidateJson.lastName,
      fname: candidateJson.firstName,
      lname: candidateJson.lastName,
      email: candidateJson.email,
      position: candidateJson.position,
      InterviewTitle: jobPosition,
      isCandidate: true,
      colorCode: getRandomDarkColor(),
      isCameraOn: true,
      isAudioOn: true,
      socketId: candidateJson.socketId,
    },
    participantOfMeeting: participantOfMeeting,
  };
}
